import './offer.css';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import MenuPlans from './MenuPlans';

const PlanGratuit = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      fontFamily: 'Inter, Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    }}>
      <MenuPlans />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18 }}>
          <div style={{
            display: 'inline-block',
            background: 'linear-gradient(135deg, #16c79e 0%, #0a795f 100%)',
            color: 'white',
            padding: '8px 20px',
            borderRadius: 50,
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 18,
            boxShadow: '0 4px 15px rgba(22,199,158,0.18)'
          }}>
            Plan de încercare gratuit
          </div>
          <h1 style={{ fontSize: '2.3rem', fontWeight: 800, marginBottom: 8, color: '#1a202c', textAlign: 'center' }}>Plan Gratuit</h1>
          <p style={{ color: '#4a5568', fontSize: '1.15rem', marginBottom: 0, textAlign: 'center', maxWidth: 420 }}>
            Încearcă platforma gratuit, fără obligații.
          </p>
        </div>
        <div className="offerdiscount-card" style={{ margin: 0, boxShadow: '0 8px 32px rgba(22,199,158,0.10), 0 2px 8px rgba(22,199,158,0.10)' }}>
          <div className="offerdiscount-price" style={{ justifyContent: 'center' }}>
            <span className="offerdiscount-price-main">0 LEI</span>
            <span style={{ fontSize: '1.1rem', color: '#6b7280', fontWeight: 500 }}>/gratuit</span>
          </div>
          <ul className="offerdiscount-benefits">
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> 5 lecții gratuite pe săptămână</li>
            <li><FontAwesomeIcon icon={faCheck} className="item-bifa" /> Acces la comunitate</li>
          </ul>
          <button
            className="offerdiscount-btn"
            style={{ marginBottom: 10 }}
            onClick={() => navigate('/registrer')}
          >
            Începe gratuit
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanGratuit;
